export function getOptions() {
    return {
        destroy: true,
        responsive: true,
        details: false,
        select: true,
        bAutoWidth: false,
        language: {
            searchPlaceholder: 'Zoeken...',
            sProcessing: 'Bezig...',
            sLengthMenu: '_MENU_',
            sZeroRecords: 'Geen resultaten gevonden',
            sInfo: '_START_ tot _END_ van _TOTAL_ resultaten',
            sInfoEmpty: 'Geen resultaten om weer te geven',
            sInfoFiltered: ' (gefilterd uit _MAX_ resultaten)',
            sInfoPostFix: '',
            sSearch: '',
            sEmptyTable: 'Geen resultaten aanwezig in de tabel',
            sInfoThousands: '.',
            sLoadingRecords: 'Een moment geduld aub - bezig met laden...',
            oPaginate: {
                sFirst: 'Eerste',
                sLast: 'Laatste',
                sNext: 'Volgende',
                sPrevious: 'Vorige'
            },
            oAria: {
                sSortAscending: ': activeer om kolom oplopend te sorteren',
                sSortDescending: ': activeer om kolom aflopend te sorteren'
            }
        },
        drawCallback() {
            var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
            pagination.toggle(this.api().page.info().pages > 1);
        }
    }
}